module.exports = __webpack_public_path__ + "static/media/meal-icon.534327f9.svg";